import { Component, AfterViewInit } from '@angular/core';
import { Title,Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-digital-marketing',
  templateUrl: './digital-marketing.component.html',
  styleUrls: ['./digital-marketing.component.css']
})
export class DigitalMarketingComponent implements AfterViewInit {
  constructor(private titleServvice:Title,private metaService: Meta){}

  ngOnInit(): void {
    this.titleServvice.setTitle('Top Digital Marketing Company in Hyderabad | Call  7075451542')
    this.metaService.addTags([
      { name: 'description', content: 'Call 7075451542 for the top digital marketing company in Hyderabad. We provide expert solutions in SEO, PPC, and social media to boost your business online.' },
      { name: 'keywords', content: 'Top Digital Marketing Company in Hyderabad' }
    ]);
  }

  // URLs for the images
  private newImageUrl: string = 'assets/digital/g2.png'; // Hover image
  private originalImageUrl: string = 'assets/digital/g.png'; // Original image

  ngAfterViewInit(): void {
    // Select the image element by its ID
    const image = document.getElementById('digitalImage') as HTMLImageElement;

    if (image) {
      // Add mouseenter (hover) event listener
      image.addEventListener('mouseenter', () => {
        image.src = this.newImageUrl; // Change to hover image
      });

      // Add mouseleave event listener
      image.addEventListener('mouseleave', () => {
        image.src = this.originalImageUrl; // Revert to the original image
      });
    } else {
      console.error('Image element with ID "digitalImage" not found.');
    }
  }
}